import { useGetHotelReports } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function HotelReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:hotel_report')}
      usePivotQuery={useGetHotelReports}
      completeName={['customer', 'admin', 'guest', 'status']}
    />
  );
}
